import { LegacyDevice } from 'console/device/device';
import { DevicePermission } from 'console/device/device_ts';
export function getFirmware(last_firmwares, hw_type, dev_type) {
    if (hw_type == null) {
        return null;
    }
    if (dev_type == null) {
        return null;
    }
    // console.log('getFirmware', last_firmwares, hw_type.code, dev_type.code);
    const firmware_by_hw = last_firmwares[hw_type.code];
    // console.log('firmware_by_hw', firmware_by_hw);
    if (firmware_by_hw == null) {
        return null;
    }
    const firmware_by_dev_type = firmware_by_hw[dev_type.code];
    // console.log('firmware_by_dev_type', firmware_by_dev_type);
    if (firmware_by_dev_type == null) {
        return null;
    }
    return firmware_by_dev_type;
}
export function getLastFirmware(firmware, obey_rollout, serial) {
    if (obey_rollout && serial != null && firmware?.rollout != null) {
        const my_rollout_id = parseInt(serial.substring(0, 2), 16);
        if (isNaN(my_rollout_id)) {
            return null;
        }
        if ((my_rollout_id / 256) * 100 > firmware.rollout) {
            return null;
        }
    }
    return firmware;
}
export function getFirmwareVersionHuman(firmware) {
    if (firmware == null) {
        return '';
    }
    const version = firmware.version.join(':');
    return version.endsWith(':1') ? version.substring(0, version.length - 2) : version;
}
export function firmwareUpgradeAvailable(fw_version, dev_type, firmware) {
    if (firmware == null) {
        return false;
    }
    if (LegacyDevice.has_thermostat_service_password(fw_version, dev_type)) {
        return false;
    }
    if (fw_version == null) {
        return false;
    }
    const last_version = firmware.version;
    return (fw_version[0] < last_version[0] ||
        (fw_version[0] === last_version[0] && fw_version[1] < last_version[1]));
}
export function hasFirmwareUpdate(user_id, last_firmwares, device, obey_rollout, only_owner) {
    if (!device) {
        return { available: false, firmware: null };
    }
    // ONLY OWNER get notifications
    if (only_owner && device.user_id != user_id) {
        return { available: false, firmware: null };
    }
    if (!LegacyDevice.has_access(user_id, device, [DevicePermission.update_firmware])) {
        return { available: false, firmware: null };
    }
    if (device.just_installed_firmware) {
        return { available: false, firmware: null };
    }
    const firmware = getLastFirmware(getFirmware(last_firmwares, device.hardware_type, device.device_type), obey_rollout, device.serial);
    return {
        available: firmwareUpgradeAvailable(device.firmware_version || null, device.device_type, firmware),
        firmware,
    };
}
export function isFirmwareDeclined(device, firmware) {
    if (device.declined_firmware_update_versions == null) {
        return false;
    }
    return device.declined_firmware_update_versions.some((declined) => declined[0] == firmware.version[0] && declined[1] == firmware.version[1]);
}
